import React from 'react';
import { motion } from 'framer-motion';
import { Pencil, Hash, DollarSign, Wrench, Package, Zap, Eye, Truck } from 'lucide-react';
const features = [{
  icon: Zap,
  title: 'Next-Day DTF',
  description: 'Most DTF transfer orders ship within 24 hours. Fast turnaround you can count on.'
}, {
  icon: Hash,
  title: 'No Minimums',
  description: 'Order one shirt or a full team run. We support small orders and large reorders alike.'
}, {
  icon: Eye,
  title: 'Clear Proofing',
  description: 'Every order gets a digital proof before production. No surprises — you approve before we print.'
}, {
  icon: DollarSign,
  title: 'No Setup Fees',
  description: 'Transparent pricing. You pay for what you order — no surprise setup charges.'
}, {
  icon: Wrench,
  title: 'Built for Real Use',
  description: 'Our apparel is made for crews, racers, and teams who actually wear their gear — not just for display.'
}, {
  icon: Truck,
  title: 'Statewide Shipping',
  description: 'Based in Morrice, MI and shipping across Michigan and nationwide. Local pickup also available.'
}, {
  icon: Pencil,
  title: 'Free Design Help',
  description: "No artwork? No problem. We help clean up, adjust, or create designs so your apparel looks right before it's printed."
}, {
  icon: Package,
  title: 'Proven & Reliable',
  description: 'Trusted by contractors, racing teams, schools, and businesses nationwide for consistent quality and fast turnaround.'
}];
export function WhyPrintAtomic() {
  return <section className="py-24 bg-atomic-black border-y border-white/5" data-id="element-436">
      <div className="container mx-auto px-4 md:px-6" data-id="element-437">
        <div className="text-center mb-16" data-id="element-438">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-439">
            Why Print Atomic?
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg" data-id="element-440">
            We focus on making custom apparel easy, affordable, and reliable for
            real-world use — from the jobsite to the racetrack.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-441">
          {features.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-atomic-charcoal p-8 rounded-xl border border-white/5 hover:border-atomic-green/30 transition-colors" data-id="element-442">
              <div className="mb-6 inline-flex items-center justify-center w-12 h-12 rounded-lg bg-atomic-dark text-atomic-green border border-white/10" data-id="element-443">
                <feature.icon size={24} data-id="element-444" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-445">
                {feature.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-446">
                {feature.description}
              </p>
            </motion.div>)}

          {/* Callout Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5,
          duration: 0.5
        }} className="bg-gradient-to-br from-atomic-green to-lime-500 p-8 rounded-xl flex flex-col justify-center items-center text-center border border-lime-400/30" data-id="element-447">
            <h3 className="text-2xl font-bold text-black mb-2" data-id="element-448">
              Ready to get started?
            </h3>
            <p className="text-black/80 mb-6" data-id="element-449">
              Get a custom quote for your next project.
            </p>
            <a href="/contact" className="w-full" data-id="element-450">
              <button className="bg-black text-atomic-green px-6 py-2 rounded-md font-bold hover:bg-atomic-charcoal transition-colors w-full" data-id="element-451">
                Get a Quote
              </button>
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}